export default {
  setObject: async function ({ commit }, { value, path }) {
    await commit("SET_OBJECT", { value, path })
  },
}
